// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__yG4AP","list":"BalanceDue_list__39vy2","listRow":"BalanceDue_listRow__1fIHD","total":"BalanceDue_total__3eS1c"};